import { z } from "zod";
//#region src/api/orpc/modelSizeConfig.ts
const SizeDisplayMode = {
	DEFAULT: "default",
	HIDDEN: "hidden",
	COLLAPSED: "collapsed"
};
const SizeDisplayModes = Object.values(SizeDisplayMode);
const sizeDisplayModeSchema = z.enum(SizeDisplayModes);
const SizeAccessStatus = {
	AVAILABLE: "available",
	MEMBERSHIP_REQUIRED: "membership_required"
};
const SizeAccessStatuses = Object.values(SizeAccessStatus);
const sizeAccessStatusSchema = z.enum(SizeAccessStatuses);
const membershipTierSchema = z.int().min(0).max(3);
const sizePresetSchema = z.object({
	id: z.uuid(),
	width: z.int().min(1),
	height: z.int().min(1),
	requiredMembershipTier: membershipTierSchema,
	displayMode: sizeDisplayModeSchema,
	sortOrder: z.int()
});
const sizeRangeObjectSchema = z.object({
	name: z.string(),
	minWidth: z.int().min(1),
	maxWidth: z.int().min(1),
	minHeight: z.int().min(1),
	maxHeight: z.int().min(1),
	step: z.int().min(1),
	requiredMembershipTier: membershipTierSchema,
	displayMode: sizeDisplayModeSchema,
	sortOrder: z.int(),
	defaultPresetId: z.uuid().nullable(),
	presets: z.array(sizePresetSchema)
});
const sizeRangeSchema = sizeRangeObjectSchema.refine((d) => d.minWidth <= d.maxWidth, { message: "minWidth must be <= maxWidth" }).refine((d) => d.minHeight <= d.maxHeight, { message: "minHeight must be <= maxHeight" });
const sizeConfigResponseSchema = z.object({ ranges: z.array(sizeRangeObjectSchema.extend({
	accessStatus: sizeAccessStatusSchema,
	presets: z.array(sizePresetSchema.extend({
		ratioLabel: z.string(),
		accessStatus: sizeAccessStatusSchema
	}))
}).refine((d) => d.minWidth <= d.maxWidth, { message: "minWidth must be <= maxWidth" }).refine((d) => d.minHeight <= d.maxHeight, { message: "minHeight must be <= maxHeight" })) });
//#endregion
export { SizeAccessStatus, SizeDisplayMode, membershipTierSchema, sizeAccessStatusSchema, sizeConfigResponseSchema, sizeDisplayModeSchema, sizePresetSchema, sizeRangeObjectSchema, sizeRangeSchema };
